import clsx from "clsx";
import HowToPlay1 from "assets/img/home/how-to-play-1.jpg";
import HowToPlay2 from "assets/img/home/how-to-play-2.jpg";
import HowToPlay3 from "assets/img/home/how-to-play-3.jpg";
import HowToPlay4 from "assets/img/home/how-to-play-4.jpg";
import HowToPlay5 from "assets/img/home/how-to-play-5.jpg";
import HowToPlay6 from "assets/img/home/how-to-play-6.jpg";
import HowToPlay7 from "assets/img/home/how-to-play-7.jpg";
import HowToPlay8 from "assets/img/home/how-to-play-8.jpg";
import HowToPlay9 from "assets/img/home/how-to-play-9.jpg";
import HowToPlay10 from "assets/img/home/how-to-play-10.jpg";

type CarouselItemProps = { title: string; image: string; description: string };

const CarouselData: Array<CarouselItemProps> = [
    {
        title: "Players join the game",
        description: "With a casual game code or as a member of a class.",
        image: HowToPlay1,
    },
    {
        title: "Prompt is revealed",
        description: "Game prompts can be in any genre, subject or style.",
        image: HowToPlay2,
    },
    {
        title: "Everyone writes",
        description: "Timed rounds get players writing right away.",
        image: HowToPlay3,
    },
    {
        title: "Everyone votes",
        description: "Anonymously, for their favourite reply to the round.",
        image: HowToPlay4,
    },
    {
        title: "Winner is locked in place",
        description: "The winning reply is locked into place for that round.",
        image: HowToPlay5,
    },
    {
        title: "Players adapt & continue",
        description: "Repeat for 5 rounds (or whatever you choose).",
        image: HowToPlay6,
    },
    {
        title: "Until you have a story!",
        description: "By the end of the game, players create a shared text.",
        image: HowToPlay7,
    },
    {
        title: "Make your own prompts",
        description: "Generate a random prompt or customise your own.",
        image: HowToPlay8,
    },
    {
        title: "Use our prompt library",
        description: "Hundreds of skill-specific prompts for you to tailor.",
        image: HowToPlay9,
    },
    {
        title: "A fun & powerful tool",
        description: "Frankenstories builds writing enthusiasm & craft skills.",
        image: HowToPlay10,
    },
];

const CarouselItem = (props: CarouselItemProps) => {
    const { description, image, title } = props;

    return (
        <div className="d-flex flex-column gap-3 px-4 justify-content-center text-center">
            <div className="mx-auto mx-lg-0 text-center">
                <img alt="" src={image} className="img-fluid" />
            </div>

            <div className="vstack gap-3 align-self-center flex-grow-0">
                <div className="h5 text-secondary">{title}</div>

                <div className="text-dark">{description}</div>
            </div>
        </div>
    );
};

export const HowToPlayCarousel = () => (
    <div className="vstack gap-4">
        <h2 className="text-secondary text-center">How to play</h2>

        <div className="carousel slide pb-6" id="carousel-how-to-play">
            <div className="carousel-indicators">
                {CarouselData.map((item, index) => (
                    <button
                        key={item.title}
                        type="button"
                        data-bs-target="#carousel-how-to-play"
                        data-bs-slide-to={index}
                        className={clsx(index === 0 && "active")}
                    >
                        <span className="visually-hidden">{item.title}</span>
                    </button>
                ))}
            </div>
            <div className="carousel-inner">
                {CarouselData.map((item, index) => (
                    <div className={clsx("carousel-item", index === 0 && "active")} key={item.title}>
                        <CarouselItem description={item.description} image={item.image} title={item.title} />
                    </div>
                ))}
            </div>
            <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carousel-how-to-play"
                data-bs-slide="prev"
            >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carousel-how-to-play"
                data-bs-slide="next"
            >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    </div>
);
